/* Every CTA below the offer scrolls to #offer (06 e): any element with data-sm-scroll="#target" (delegated).
   Smooth scroll honoring scroll-margin-top, instant with prefers-reduced-motion, then focus moves to the selected plan card
   (or the target) without scrolling again, and the URL hash updates without a jump. CTAs never add to cart.
   Also handles pre-lander CTA mode 2 (data-sm-cta="scroll" data-target="#offer") and opens #faq-cN rows from the hash. */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(selector, trigger) {
    let target;
    try { target = document.querySelector(selector); } catch (e) { return false; }
    if (!target) return false;
    target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
    const focusEl = selector === '#offer' ? target.querySelector('.plan[aria-checked="true"]') || target : target;
    if (focusEl) {
      if (!focusEl.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(focusEl.tagName)) focusEl.setAttribute('tabindex', '-1');
      setTimeout(() => focusEl.focus({ preventScroll: true }), reduce() ? 0 : 450);
    }
    try { history.replaceState(history.state, '', selector); } catch (e) {}
    return true;
  }
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-sm-scroll], [data-sm-cta="scroll"]');
    if (!el) return;
    const sel = el.getAttribute('data-sm-scroll') || el.getAttribute('data-target') || '#offer';
    if (go(sel, el)) e.preventDefault();
  });
  // Optional: open an FAQ row when the URL hash matches its id (e.g. #faq-c3)
  const openFromHash = () => {
    const h = window.location.hash;
    if (!h || h.length < 2) return;
    let row; try { row = document.querySelector(h); } catch (e) { return; }
    if (row && row.matches('[data-sm-acc-item]')) {
      const btn = row.querySelector('[aria-expanded]');
      if (btn && btn.getAttribute('aria-expanded') === 'false') btn.click();
    }
  };
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'complete') openFromHash(); else window.addEventListener('load', openFromHash);
})();
